module.exports = __webpack_public_path__ + "img/icon04.2f3c349e.jpg";